import { $api } from "@/lib/api-client";

export const useStatementVoteMine = (id: string, enabled: boolean) =>
  $api.useQuery(
    "get",
    "/statements/{id}/votes/mine",
    { params: { path: { id } } },
    { enabled },
  );
